import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { DrawerLayoutWrapper } from 'common';
import ProgressBar from 'feature/dispatching/components/ProgressBar';
import LocationsForm from '../components/LocationsForm';
import { useGetNewLocationsForTrailerQuery } from '../../trailerStatusEndpoints';

const lens = R.lensProp('locations');

const Locations = ({ onClose, next, locationState, setLocationState }) => {
  const { locations } = locationState;

  const { viewById } = useParams();
  const params = { trailerId: viewById };
  const { data = [], isLoading } = useGetNewLocationsForTrailerQuery({ params });

  const isInvalid = R.o(R.gt(1), R.path(['locations', 'length']))(locationState);

  const handleAdd = locationId => {
    const over = R.append(locationId);
    setLocationState(R.over(lens, over));
  };

  const handleRemove = locationId => {
    const over = R.reject(R.equals(locationId));
    setLocationState(R.over(lens, over));
  };

  const buttons = (
    <Box sx={{ display: 'flex', justifyContent: 'space-around', width: 1 }}>
      <Button disabled={isInvalid} onClick={next} sx={{ width: 150 }}>
        Submit
      </Button>
    </Box>
  );

  return (
    <DrawerLayoutWrapper
      buttons={buttons}
      headerButtonText="CLOSE"
      isLoading={isLoading}
      onHeaderButtonClick={onClose}
      title="Add Location"
    >
      <ProgressBar
        label="Locations (1 of 2)"
        sx={{
          '&.MuiLinearProgress-colorPrimary > .MuiLinearProgress-bar': {
            borderRadius: '10px',
          },
        }}
        value={50}
      />
      <Stack sx={{ mt: 3, width: 390 }}>
        <LocationsForm
          locations={locations}
          onAdd={handleAdd}
          onRemove={handleRemove}
          selectableLocations={data}
        />
      </Stack>
    </DrawerLayoutWrapper>
  );
};

Locations.propTypes = {
  locationState: PropTypes.shape({
    locations: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  next: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  setLocationState: PropTypes.func.isRequired,
};

export default Locations;
